"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestedShiftRateMatch = void 0;
exports.instanceOfSuggestedShiftRateMatch = instanceOfSuggestedShiftRateMatch;
exports.SuggestedShiftRateMatchFromJSON = SuggestedShiftRateMatchFromJSON;
exports.SuggestedShiftRateMatchFromJSONTyped = SuggestedShiftRateMatchFromJSONTyped;
exports.SuggestedShiftRateMatchToJSON = SuggestedShiftRateMatchToJSON;
exports.SuggestedShiftRateMatchToJSONTyped = SuggestedShiftRateMatchToJSONTyped;
/**
 * Which rung of the fallback matched, or null when the facility has nothing to suggest. Callers use this to label the suggestion.
 * @export
 */
exports.SuggestedShiftRateMatch = {
    NurseSpecialty: 'NURSE_SPECIALTY',
    NurseAny: 'NURSE_ANY',
    FacilitySpecialty: 'FACILITY_SPECIALTY',
    FacilityAny: 'FACILITY_ANY'
};
function instanceOfSuggestedShiftRateMatch(value) {
    for (const key in exports.SuggestedShiftRateMatch) {
        if (Object.prototype.hasOwnProperty.call(exports.SuggestedShiftRateMatch, key)) {
            if (exports.SuggestedShiftRateMatch[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function SuggestedShiftRateMatchFromJSON(json) {
    return SuggestedShiftRateMatchFromJSONTyped(json, false);
}
function SuggestedShiftRateMatchFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SuggestedShiftRateMatchToJSON(value) {
    return value;
}
function SuggestedShiftRateMatchToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=SuggestedShiftRateMatch.js.map